import { trpc } from '@tencent/tpro_rmonitor_manage_server_domain_manage';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';

export type IUpsertDomainTagsRequest = WithTypeCast<trpc.rmonitor.manage_server.IUpsertDomainTagsRequest>;
export type IUpsertDomainTagsResponse = WithTypeCast<trpc.rmonitor.manage_server.IUpsertDomainTagsResponse>;
export type IDeleteDomainTagsRequest = WithTypeCast<trpc.rmonitor.manage_server.IDeleteDomainTagsRequest>;
export type IDeleteDomainTagsResponse = WithTypeCast<trpc.rmonitor.manage_server.IDeleteDomainTagsResponse>;
export type IListDomainTagsRequest = WithTypeCast<trpc.rmonitor.manage_server.IListDomainTagsRequest>;
export type IListDomainTagsResponse = WithTypeCast<trpc.rmonitor.manage_server.IListDomainTagsResponse>;
export type IDomainTagItem = WithTypeCast<trpc.rmonitor.manage_server.IDomainTagItem>;

/**
 * 域名管理
 */
export class DomainManageService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.DomainTagService,
    });
  }

  /**
   * 新增/更新域名标签
   */
  public async upsertDomainTags(req: IUpsertDomainTagsRequest): Promise<IUpsertDomainTagsResponse> {
    try {
      return await this.trpcPost<IUpsertDomainTagsResponse>('UpsertDomainTags', req);
    } catch (e) {
      console.log('[AI-DEBUG] upsertDomainTags error', e);
      return {};
    }
  }

  /**
   * 删除域名标签
   */
  public async deleteDomainTags(req: IDeleteDomainTagsRequest): Promise<IDeleteDomainTagsResponse> {
    try {
      return await this.trpcPost<IDeleteDomainTagsResponse>('DeleteDomainTags', req);
    } catch (e) {
      console.log('[AI-DEBUG] deleteDomainTags error', e);
      return {};
    }
  }

  /**
   * 列出域名标签
   */
  public async listDomainTags(req: IListDomainTagsRequest): Promise<IListDomainTagsResponse> {
    try {
      return await this.trpcPost<IListDomainTagsResponse>('ListDomainTags', req);
    } catch (e) {
      console.log('[AI-DEBUG] listDomainTags error', e);
      return {};
    }
  }
}

export const domainManageService = new DomainManageService();
